export default __webpack_public_path__ + "static/media/Nesha_Laser_0007_Smoke.4cd09191.png";